import axios from 'axios';
import { useState } from 'react'
import Button from './Button';
import DrinkDetail from './DrinkDetail';

const DrinkList = () => {
    const [search, setSearch] = useState([]);
    const [items, setItems] = useState([]);
    const API_URL = `https://www.thecocktaildb.com/api/json/v1/1/search.php?s=${search}&api_key=1`

    const searchResult = (e) => {
        e.preventDefault();        
        axios.get(API_URL).then(response => {
            setItems(response.data)
        console.log(response);
        })
        .catch(function (error) {
        // handle error
        console.log(error);
        })
            .then(function () {
        // always executed
        });
        
    }

    return (
        <div className="mb-auto bg-white/75">
            <h2 className="text-3xl m-3">Drink List</h2> 
            <label htmlFor="search">What do you want to drink today? </label> <br />
            <form action="" onSubmit={searchResult}>
            <input className='border-2 border-black rounded text-sky-500' type="text" id='search' placeholder="It's 5 o'clock somewhere..." 
            onChange={e => setSearch(e.target.value)} />
            <Button btnName={'Search'} />
            </form>
            <div>
                <DrinkDetail items={items} />
            </div>
        </div>
    )
}

export default DrinkList
